<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="22"> </caass-schoolselector>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Grade</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GradeLevelID" [(ngModel)]="report.GradeLevelID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of gradeList" [ngValue]="o.GradeLevelID">
									{{ o.GradeLevelDesc }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Academy</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="AcademyID" [(ngModel)]="report.AcademyID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of academyList" [ngValue]="o.AcademyID">
									{{ o.AcademyDesc }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Homeroom</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="HomeroomID" [(ngModel)]="report.HomeroomID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of homeroomList" [ngValue]="o.HomeroomID">
									{{ o.HomeroomDesc }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Group</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GroupID" [(ngModel)]="report.GroupID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of groupList" [ngValue]="o.GroupID">
									{{ o.GroupName }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="selectDisplaysID" [(ngModel)]="report.SortBy">
								<option *ngFor="let o of lstSortBy" [ngValue]="o.SortByDesc">
									{{ o.SortByDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
